module.exports = __webpack_public_path__ + "static/img/taxcellent_bg.7b51fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/taxcellent_bg.png
// module id = tQBj
// module chunks = 34